<template>
  <v-form v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <keyword-select
            :filled="false"
            :showNew="false"
            :hide-details="true"
            :value.sync="fields.keyword"
            @enter="submit">
        </keyword-select>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <website-select
            :filled="false"
            :showNew="false"
            :hide-details="true"
            :value.sync="fields.domain"
            @enter="submit">
        </website-select>
      </v-col>
      <v-col cols="6" md="2">
        <country-select :filled="false" :value.sync="fields.country" @enter="submit"></country-select>
      </v-col>
      <v-col cols="6" md="2">
        <language-select :filled="false" :value.sync="fields.language" @enter="submit"></language-select>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn color="success" :loading="this.$api.loading('checks')" :disabled="!valid" @click="submit" block large
               style="height: 48px;">
          <v-icon left>mdi-magnify</v-icon>
          {{ $t('actions.check') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import WebsiteSelect from '@/views/Common/Components/Selects/WebsiteSelect'
import KeywordSelect from '@/views/Common/Components/Selects/KeywordSelect'
import CountrySelect from '@/views/Common/Components/Selects/CountrySelect'
import LanguageSelect from '@/views/Common/Components/Selects/LanguageSelect'
export default {
  name: 'PageForm',
  components: { LanguageSelect, CountrySelect, KeywordSelect, WebsiteSelect },
  data () {
    return {
      valid: false,
      fields: {
        domain: '',
        keyword: '',
        language: 'en',
        country: 'en',
      },
      rules: {
        domain: [v => !!v],
        keyword: [v => !!v]
      },
      fresh: null
    }
  },
  watch: {
    fields: {
      handler () {
        const emptyDomain = this.fields.domain === '' || this.fields.domain === null
        const emptyKeyword = this.fields.keyword === '' || this.fields.keyword === null
        if(!emptyDomain && !emptyKeyword) {
          this.$refs['form'].validate()
        }
      },
      deep: true
    }
  },
  methods: {
    async submit () {
      if (this.$refs.form.validate()) {
        // Memorize if the user is authenticated
        this.$autocompletion.add('domains', this.fields.domain)
        this.$autocompletion.add('keywords', this.fields.keyword)

        try {
          const response = await this.$api.post('checks', this.fields)
          this.fields.keyword = ''
          this.$emit('submit', { check: response.data })
        } catch(err) {
          if (err.exception === 'ThrottledCreateCheckException') {
            if (this.$account.isVerified) {
              this.$bus.emit('notification/payment_required_for_more_checks')
            } else {
              this.$bus.emit('notification/account_required_for_more_checks')
            }
          }
        }
      }
    },
  },
  mounted () {
    this.fields.language = this.$account.current.language
    this.fields.country = this.$account.current.country
  }
}
</script>

<style>
@media screen and (min-width: 960px) {
  .responsive-bottom-margin {
    margin-bottom: -34px;
  }
}
</style>

<i18n>
{
	"en": {
		"fields-country": "Geolocation",
		"fields-domain": "Website",
		"fields-keyword": "Keyword",
		"fields-language": "Language"
	},
	"es": {
		"fields-country": "Geolocalización",
		"fields-domain": "Sitio Web",
		"fields-keyword": "Palabra clave",
		"fields-language": "Lengua"
	},
	"fr": {
		"fields-country": "Géolocalisation",
		"fields-domain": "Site web",
		"fields-keyword": "Mot clé",
		"fields-language": "Langue"
	},
	"it": {
		"fields-country": "Geolocalizzazione",
		"fields-domain": "Sito web",
		"fields-keyword": "Parola chiave",
		"fields-language": "Lingua"
	},
	"pt": {
		"fields-country": "Geolocalização",
		"fields-domain": "Website",
		"fields-keyword": "Palavra-chave",
		"fields-language": "Idioma"
	},
	"pl": {
		"fields-country": "Geolokalizacja",
		"fields-domain": "Strona internetowa",
		"fields-keyword": "Słowo kluczowe",
		"fields-language": "Język"
	}
}
</i18n>
